var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownPreviousArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "down_previous_arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "next_arrow",
    d: "M9.99264 23.7385C10.7847 24.4405 11.9991 24.3721 12.7023 23.5789C13.4067 22.7857 13.3359 21.5724 12.5427 20.868L7.67775 16.5431H13.1885C21.1292 16.5431 27.5889 10.0834 27.5889 2.14271C27.5889 1.08309 26.7284 0.222658 25.6688 0.222658C24.6092 0.222658 23.7488 1.08309 23.7488 2.14271C23.7488 7.96524 19.011 12.703 13.1885 12.703H7.67775L12.5427 8.37813C13.3359 7.6737 13.4067 6.46047 12.7023 5.66726C12.3243 5.24125 11.7975 5.02282 11.2683 5.02282C10.8146 5.02282 10.3586 5.18243 9.99383 5.50763L1.35359 13.1878C0.941992 13.5527 0.707958 14.0747 0.707958 14.6231C0.707958 15.1715 0.941967 15.6935 1.35239 16.0583L9.99264 23.7385Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownPreviousArrow);
export default __webpack_public_path__ + "static/media/down_previous_arrow.cd3eda0d25697030731c410207c7d668.svg";
export { ForwardRef as ReactComponent };